// extracted by mini-css-extract-plugin
module.exports = {"selectInput":"SelectInput__selectInput___3efO4"};


// WEBPACK FOOTER //
// ./webpack:/aws_amplify_ui/src/SelectInput.css?12a6